/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Env_ContainersInputs */

const en_svchip_env_containers = /** @type {(inputs: Svchip_Env_ContainersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Env containers`)
};

const ar_svchip_env_containers = /** @type {(inputs: Svchip_Env_ContainersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حاويات البيئة`)
};

const bn_svchip_env_containers = /** @type {(inputs: Svchip_Env_ContainersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Env কন্টেইনার`)
};

const de_svchip_env_containers = /** @type {(inputs: Svchip_Env_ContainersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Env-Container`)
};

const es_svchip_env_containers = /** @type {(inputs: Svchip_Env_ContainersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenedores ambientales`)
};

const fr_svchip_env_containers = /** @type {(inputs: Svchip_Env_ContainersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteneurs d'environnement`)
};

const pt_svchip_env_containers = /** @type {(inputs: Svchip_Env_ContainersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contêineres de ambiente`)
};

const zh_svchip_env_containers = /** @type {(inputs: Svchip_Env_ContainersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`环境容器`)
};

const tr_svchip_env_containers = /** @type {(inputs: Svchip_Env_ContainersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarf kapsayıcıları`)
};

const ru_svchip_env_containers = /** @type {(inputs: Svchip_Env_ContainersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контейнеры конвертов`)
};

const pl_svchip_env_containers = /** @type {(inputs: Svchip_Env_ContainersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontenery Env`)
};

/**
* | output |
* | --- |
* | "Env containers" |
*
* @param {Svchip_Env_ContainersInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_env_containers = /** @type {((inputs?: Svchip_Env_ContainersInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Env_ContainersInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_env_containers(inputs)
	if (locale === "bn") return bn_svchip_env_containers(inputs)
	if (locale === "de") return de_svchip_env_containers(inputs)
	if (locale === "es") return es_svchip_env_containers(inputs)
	if (locale === "fr") return fr_svchip_env_containers(inputs)
	if (locale === "pt") return pt_svchip_env_containers(inputs)
	if (locale === "zh") return zh_svchip_env_containers(inputs)
	if (locale === "tr") return tr_svchip_env_containers(inputs)
	if (locale === "ru") return ru_svchip_env_containers(inputs)
	if (locale === "pl") return pl_svchip_env_containers(inputs)
	return en_svchip_env_containers(inputs)
});